module.exports = __webpack_public_path__ + "static/widgets_1-8c9ed52f92949d0a3976a5a4f957b25c.png";